// 抽屉优先占视口的 60%，至少 48rem；窄屏以视口宽度为上限，避免溢出。
export const DRAWER_SIZE = 'min(100vw, max(60vw, 48rem))'
